import PropTypes from "prop-types"

import { serviceShape, tqaShape } from "app/lib/shared_prop_types"
import proPlusBadge from "images/plan-badges/pro_plus.svg"
import proBadge from "images/plan-badges/pro.svg"

import "./header.scss"

const TQAHeader = ({ service, tqa, servicePath, serviceImg }) => (
  <section className="service-header">
    <div className="brand-section" styleName="brand-section">
      <a
        href={servicePath}
        title={service.name}
        rel="noreferrer"
        styleName="brand-link"
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify({
          object_type: "service_link",
          object_id: service.name,
          location_type: "tqa_info",
        })}
      >
        <img
          styleName="small-service-logo"
          src={serviceImg}
          alt={service.name}
          title={service.name}
          width="32"
          height="32"
        />
        {service.name}
      </a>
      <h1>{tqa.name}</h1>
      <p styleName="brand-description">
        {tqa.tier !== "free" && (
          <span
            className="card-badge"
            dangerouslySetInnerHTML={{
              __html: tqa.tier === "pro" ? proPlusBadge : proBadge,
            }}
          />
        )}
        {tqa.description}
      </p>
    </div>
  </section>
)

TQAHeader.propTypes = {
  service: serviceShape.isRequired,
  tqa: tqaShape.isRequired,
  servicePath: PropTypes.string.isRequired,
  serviceImg: PropTypes.string.isRequired,
}

export default TQAHeader
